/**
 * 展示服务
 * 处理展示相关的API调用
 */

import httpClient from './httpClient';
import { API_ENDPOINTS } from './config';
import { ShowcaseItem, ListParams, PageResponse } from './types';

class ShowcaseService {
  /**
   * 获取展示列表
   */
  public async getShowcaseList(params: ListParams = {}): Promise<PageResponse<ShowcaseItem>> {
    try {
      const response = await httpClient.get<PageResponse<ShowcaseItem>>(
        API_ENDPOINTS.SHOWCASE.LIST,
        { params }
      );

      if (response.success) {
        return response.data;
      } else {
        throw new Error(response.message || '获取展示列表失败');
      }
    } catch (error) {
      console.error('获取展示列表失败:', error);
      throw error;
    }
  }

  /**
   * 获取展示详情
   */
  public async getShowcaseDetail(id: number): Promise<ShowcaseItem> {
    try {
      const response = await httpClient.get<ShowcaseItem>(
        `${API_ENDPOINTS.SHOWCASE.DETAIL}/${id}`
      );

      if (response.success) {
        return response.data;
      } else {
        throw new Error(response.message || '获取展示详情失败');
      }
    } catch (error) {
      console.error('获取展示详情失败:', error);
      throw error;
    }
  }

  /**
   * 创建展示
   */
  public async createShowcase(showcase: Partial<ShowcaseItem>): Promise<ShowcaseItem> {
    try {
      const response = await httpClient.post<ShowcaseItem>(
        API_ENDPOINTS.SHOWCASE.CREATE,
        showcase
      );

      if (response.success) {
        return response.data;
      } else {
        throw new Error(response.message || '创建展示失败');
      }
    } catch (error) {
      console.error('创建展示失败:', error);
      throw error;
    }
  }

  /**
   * 更新展示
   */
  public async updateShowcase(id: number, showcase: Partial<ShowcaseItem>): Promise<ShowcaseItem> {
    try {
      const response = await httpClient.put<ShowcaseItem>(
        `${API_ENDPOINTS.SHOWCASE.UPDATE}/${id}`,
        showcase
      );

      if (response.success) {
        return response.data;
      } else {
        throw new Error(response.message || '更新展示失败');
      }
    } catch (error) {
      console.error('更新展示失败:', error);
      throw error;
    }
  }

  /**
   * 删除展示
   */
  public async deleteShowcase(id: number): Promise<void> {
    try {
      const response = await httpClient.delete(
        `${API_ENDPOINTS.SHOWCASE.DELETE}/${id}`
      );

      if (!response.success) {
        throw new Error(response.message || '删除展示失败');
      }
    } catch (error) {
      console.error('删除展示失败:', error);
      throw error;
    }
  }

  /**
   * 根据分类获取展示列表
   */
  public async getShowcasesByCategory(category: string, params: ListParams = {}): Promise<PageResponse<ShowcaseItem>> {
    return this.getShowcaseList({ ...params, keyword: category });
  }

  /**
   * 搜索展示
   */
  public async searchShowcases(keyword: string, params: ListParams = {}): Promise<PageResponse<ShowcaseItem>> {
    return this.getShowcaseList({ ...params, keyword });
  }
}

// 创建展示服务实例
const showcaseService = new ShowcaseService();

export default showcaseService;
